export default __webpack_public_path__ + "static/media/research5.5e7807a6.jpg";